module.exports = __webpack_public_path__ + "static/img/10.3f5ef67e.png";